import {
  AdditionalOrderStatuses,
  FULFILLMENT_STATE_CANCELED,
  FULFILLMENT_STATE_COMPLETED,
  FULFILLMENT_STATE_REJECTED,
  ORDER_STATE_CANCELED,
  ORDER_STATE_COMPLETED,
  ORDER_STATE_PROCESSING,
  RETAILER_STATE_CANCELED,
  RETAILER_STATE_ORDERED,
} from '../constants/orderStates';
import {
  ORDER_TYPE_DROPSHIP,
  ORDER_TYPE_ECOMMERCE,
  ORDER_TYPE_MARKETPLACE,
  ORDER_TYPE_REORDER,
  ORDER_TYPE_REPLENISH,
} from '../constants/orderTypes';

export function isOrderInState(currentState, desiredStates) {
  return desiredStates.some((state) => currentState === state);
}

export function simplifyFulfillmentStatus(state) {
  return AdditionalOrderStatuses[state];
}

export function getBgColor({ label, additionalInfo, options }) {
  if (options.isOrderTypeStatus) {
    const orderTypeStatusColorMap = {
      [ORDER_TYPE_DROPSHIP]: 'primary',
      [ORDER_TYPE_ECOMMERCE]: 'secondary',
      [ORDER_TYPE_MARKETPLACE]: 'warning',
      [ORDER_TYPE_REORDER]: 'info',
      [ORDER_TYPE_REPLENISH]: 'dark',
    };
    return orderTypeStatusColorMap[label] ?? 'primary';
  }

  if (additionalInfo) {
    return [AdditionalOrderStatuses['expired'], AdditionalOrderStatuses['late']].some((state) => state === label)
      ? 'warning'
      : 'info';
  }
  return isOrderInState(label, [
    AdditionalOrderStatuses['canceled'],
    FULFILLMENT_STATE_REJECTED,
    FULFILLMENT_STATE_CANCELED,
  ])
    ? 'dark'
    : isOrderInState(label, [
        AdditionalOrderStatuses['fulfilled_partially'],
        AdditionalOrderStatuses['fulfilled'],
        FULFILLMENT_STATE_COMPLETED,
      ])
    ? 'secondary'
    : 'primary';
}

export function filterOrdersByStates(filter, title) {
  switch (title) {
    case ORDER_STATE_COMPLETED:
      filter.retailer_state = {
        $eq: RETAILER_STATE_ORDERED,
      };
      filter.processing_state = {
        $eq: ORDER_STATE_COMPLETED,
      };
      break;

    case ORDER_STATE_CANCELED:
      Object.assign(filter, {
        $or: [
          {
            retailer_state: {
              $eq: RETAILER_STATE_CANCELED,
            },
          },
          {
            processing_state: {
              $eq: ORDER_STATE_CANCELED,
            },
          },
        ],
      });
      break;

    case ORDER_STATE_PROCESSING:
      filter.retailer_state = {
        $eq: RETAILER_STATE_ORDERED,
      };
      filter.processing_state = {
        $notIn: [ORDER_STATE_COMPLETED, ORDER_STATE_CANCELED],
      };
      break;

    default:
      break;
  }
}

export function filterOrdersBySearch(filter, search) {
  if (!search) return;

  const $orClause = [
    {
      retailer_order_id: {
        $like: `%${search}%`,
      },
    },
    {
      sales_order_number: {
        $like: `%${search}%`,
      },
    },
  ];

  if (!filter.$or) {
    filter.$or = $orClause;
    return;
  }

  filter.$and = [{ $or: filter.$or }, { $or: $orClause }];
  delete filter.$or;
}
